var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7053 2.02637H4.34809V12.3836H14.7053V2.02637ZM7.90839 7.8523H6.29007V9.14695H5.31908V5.263H7.90839V7.8523ZM11.145 8.17597C11.145 8.71325 10.7113 9.14695 10.174 9.14695H8.55571V5.263H10.174C10.7113 5.263 11.145 5.69671 11.145 6.23399V8.17597ZM13.7343 6.23399H12.7633V6.88131H13.7343V7.8523H12.7633V9.14695H11.7923V5.263H13.7343V6.23399ZM6.29007 6.88131H6.9374V6.23399H6.29007V6.88131ZM3.05344 4.61567H1.75879V14.9729H12.116V13.6782H3.05344V4.61567ZM9.5267 8.17597H10.174V6.23399H9.5267V8.17597Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.713c8f6f.svg";
export { ForwardRef as ReactComponent };